import { render } from "./detail-result-vivo.vue?vue&type=template&id=105c6219"
import script from "./detail-result-vivo.vue?vue&type=script&lang=js"
export * from "./detail-result-vivo.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__